var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"outlines-button",attrs:{"href":_vm.link,"title":_vm.text,"target":"target"}},[_c('div',{staticClass:"outlines-button__frame"},[_c('span',{staticClass:"outlines-button__text"},[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }